export const HELP_URL = 'https://avenhospitality.mcoutput.com/help/Default.htm';


// WEBPACK FOOTER //
// ./src/constants/HelpFile.js